import {
  Component, EventEmitter, Input, Output
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { BlackButtonService } from "@app/shared/services/black-button/black-button.service";
import * as bootstrapIcons from "@ng-icons/bootstrap-icons";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import * as outline from "@ng-icons/heroicons/outline";
import * as solid from "@ng-icons/heroicons/solid";

@Component({
  selector: "app-black-button",
  standalone: true,
  imports: [NgIconComponent, RouterModule],
  viewProviders: [provideIcons({ ...outline, ...solid, ...bootstrapIcons })],
  templateUrl: "./black-button.component.html",
  styleUrl: "./black-button.component.scss",
})
export class BlackButtonComponent {
  @Input() iconSize = "25";
  @Input() widthFitContent: boolean = false;
  @Input() showIcon: boolean = true;
  @Input() buttonText: string = "";
  @Input() iconName: string = "heroPlusCircleSolid";
  @Input() routePath: string = "";
  @Input() redirect: boolean = true;
  @Output() buttonClick = new EventEmitter<void>();

  constructor(private blackButtonService: BlackButtonService) {
    if (this.blackButtonService.data) {
      this.blackButtonService.data.subscribe((value) => {
        this.buttonText = value.text;
        this.routePath = value.route;
      });
    }
  }

  emitClick() {
    this.buttonClick.emit();
  }
}
